import React, { useState } from 'react';
import { ChevronRight, ChevronDown, Folder, FolderOpen } from 'lucide-react';

const TreeItem = ({ node, path, isActive, onNavigate, level = 0 }) => {
  const [isExpanded, setIsExpanded] = useState(level === 0 || level === 1);

  if (node.type !== 'folder' || !node.children) {
    return null;
  }

  const hasChildren = Object.keys(node.children).length > 0;

  const handleClick = () => {
    onNavigate(path.join('/'));
  };

  const handleToggle = (e) => {
    e.stopPropagation();
    setIsExpanded(!isExpanded);
  };

  // If this is the root level (level 0), skip rendering this node and directly render children
  if (level === 0) {
    return (
      <div className="space-y-1">
        {hasChildren &&
          Object.entries(node.children)
            .filter(([key, child]) => child.type === 'folder')
            .sort(([a], [b]) => a.localeCompare(b))
            .map(([key, child]) => (
              <TreeItem
                key={key}
                node={child}
                path={[key]}
                isActive={path.join('/') + '/' + key === window.location.hash.replace('#', '')}
                onNavigate={onNavigate}
                level={1}
              />
            ))
        }
      </div>
    );
  }

  const childrenNodes = isExpanded && hasChildren ?
    Object.entries(node.children)
      .filter(([key, child]) => child.type === 'folder')
      .sort(([a], [b]) => a.localeCompare(b))
      .map(([key, child]) => (
        <TreeItem
          key={key}
          node={child}
          path={[...path, key]}
          isActive={path.join('/') + '/' + key === window.location.hash.replace('#', '')}
          onNavigate={onNavigate}
          level={level + 1}
        />
      )) : null;

  return (
    <div>
      <div
        className={`flex items-center gap-2 px-3 py-2 rounded-lg cursor-pointer text-sm transition-all mb-0.5 ${isActive
            ? 'bg-blue-50 dark:bg-blue-950 text-blue-700 dark:text-blue-300 font-medium'
            : 'text-slate-600 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-700 hover:text-slate-900 dark:hover:text-slate-100'
          }`}
        style={{ paddingLeft: `${(level - 1) * 1.2 + 0.75}rem` }}
        onClick={handleClick}
      >
        {hasChildren && (
          <button
            onClick={handleToggle}
            className="p-0.5 hover:bg-slate-200 dark:hover:bg-slate-600 rounded transition-colors"
          >
            {isExpanded ? (
              <ChevronDown className="w-3.5 h-3.5" />
            ) : (
              <ChevronRight className="w-3.5 h-3.5" />
            )}
          </button>
        )}
        {!hasChildren && <div className="w-4" />}
        {isExpanded && hasChildren ? (
          <FolderOpen className={`w-4 h-4 flex-shrink-0 ${isActive ? 'text-blue-500' : 'text-slate-400'}`} />
        ) : (
          <Folder className={`w-4 h-4 flex-shrink-0 ${isActive ? 'text-blue-500' : 'text-slate-400'}`} />
        )}
        <span className="truncate">{node.name}</span>
      </div>
      {childrenNodes && (
        <div className="ml-3 pl-3 border-l border-slate-200 dark:border-slate-700">
          {childrenNodes}
        </div>
      )}
    </div>
  );
};

export default TreeItem;
